<template>
    <div>
        <PreparingCharger
            v-if="isShowPreparing"
            :subtitle="preparingSubtitle"
        />
    </div>
</template>

<script>
import {
    borrow,
    completePaymentOrder,
    confirmSubscriptionPayment,
} from "../../api/logined";
import PreparingCharger from "../../components/loading/PreparingCharger.vue";
import { borrowWithStationBusyRetry } from "@/services/borrowRetry";

export default {
    name: "MoyasarRedirect",
    components: {
        PreparingCharger,
    },
    data() {
        return {
            isShowPreparing: false,
            borrowStationBusyWaiting: false,
        };
    },
    computed: {
        preparingSubtitle() {
            return this.borrowStationBusyWaiting
                ? this.$t("m.preparingStationBusySubtitle")
                : "";
        },
    },
    async created() {
        const status = String(this.$route.query.status || "")
            .trim()
            .toLowerCase();
        const detail = String(this.$route.query.message || "").trim();

        if (
            status === "cancel" ||
            status === "canceled" ||
            status === "cancelled"
        ) {
            this.backToPaymentSelect(
                this.$t("tMsg.paymentCancelled") ||
                    this.$t("tMsg.paymentFailed")
            );
            return;
        }

        if (status === "failed" || status === "fail" || status === "error") {
            const prefix = this.$t("tMsg.paymentFailed");
            this.backToPaymentSelect(
                detail ? `${prefix}: ${detail}` : prefix
            );
            return;
        }

        const redirect = await this.$store.dispatch("redirect/consumeRedirect");
        if (!redirect || !redirect.flow) {
            this.backToPaymentSelect(
                `${this.$t("tMsg.paymentFailed")}: Missing payment context`
            );
            return;
        }

        this.showLoading();
        this.isShowPreparing = true;

        try {
            if (redirect.flow === "moyasarSaveAndBorrow") {
                await this.handleSaveAndBorrow(redirect.context || {});
                return;
            }

            if (redirect.flow === "moyasarSubscriptionConfirm") {
                await this.handleSubscriptionConfirm(redirect.context || {});
                return;
            }

            this.backToPaymentSelect(
                `${this.$t("tMsg.paymentFailed")}: Unsupported payment flow`
            );
        } catch (error) {
            const prefix = this.$t("tMsg.paymentFailed");
            const message = error?.message ? `${prefix}: ${error.message}` : prefix;
            this.backToPaymentSelect(message);
        } finally {
            this.borrowStationBusyWaiting = false;
            this.hideLoading();
            this.isShowPreparing = false;
        }
    },
    methods: {
        backToPaymentSelect(toastMsg) {
            this.$router.replace({
                name: "payment_select",
                query: toastMsg ? { toast_msg: toastMsg } : undefined,
            });
        },
        async handleSaveAndBorrow(context) {
            if (context.rent_payment_id) {
                await completePaymentOrder({
                    rent_payment_id: context.rent_payment_id,
                    reuse_status: 0,
                });
            }

            await borrowWithStationBusyRetry(
                () => borrow({
                    code: this.$store.getters["appConfig/device_code"],
                    subscription_id: context.subscription_id,
                }),
                {
                    onStationBusyChange: (waiting) => {
                        this.borrowStationBusyWaiting = waiting;
                    },
                }
            );

            this.$router.replace({ name: "borrow_success" });
        },
        async handleSubscriptionConfirm(context) {
            if (!context.internal_id) {
                throw new Error("Missing internal_id");
            }

            await confirmSubscriptionPayment({
                internal_id: context.internal_id,
                request_from: 1,
                auto_renew: context.auto_renew,
            });

            this.backToPaymentSelect(this.$t("tMsg.subscriptionSuccess"));
        },
    },
};
</script>
